/* eslint-disable */

import 'slick-carousel';

export function replaceEmail() {
  let link = document.querySelector('footer .contact__mail a');
  let spans = [
    document.createElement('span'),
    document.createElement('span')
  ];
  let content = link.innerText.match(/^(.*\[@\])(.*)$/);

  link.innerHTML = "";
  spans
    .map((s, i) => {
      s.innerText = content[i+1];
      return s;
    })
    .forEach(s => {
      link.appendChild(s)
    });

  // console.log(spans);
  // console.log("hey!???");
}

export function enableCarousels() {
  // console.log(slick);
  // let afterChangeEvent = false;
  let setPositionEvent, firstToLastEvent, lastToFirstEvent;
  setPositionEvent = firstToLastEvent = lastToFirstEvent = false;
  setTimeout( () => {
    $('footer .js-reference-avis').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 1,
      arrows: false,
      fade: true,
      asNavFor: 'footer .js-reference-list'
    });
    var reference_list = $('footer .js-reference-list');
    reference_list.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 1,
      asNavFor: 'footer .js-reference-avis',
      arrows: false,
      centerMode: true,
      centerPadding: '6.875%',
      // centerPadding: '0%',
      focusOnSelect: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            // centerMode: false,
            centerPadding: '0%',
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 1023,
          settings: {
            // centerMode: false,
            centerPadding: '0%',
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true
          }
        },
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 1,
        //     centerPadding: '8.28125%',
        //     arrows: false
        //   }
        // }
      ]
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      // console.log('reference_list , currentSlide, nextSlide', event, slick, currentSlide, nextSlide);
      // console.log('reference_list slick currentDirection direction', slick.currentDirection, slick.direction);
      // console.log('reference_list slick-current nextAll', $('.js-reference-list').find('.slick-current').nextAll());
      // console.log('reference_list slick-current prevAll', $('.js-reference-list').find('.slick-current').prevAll());
      setPositionEvent = firstToLastEvent = lastToFirstEvent = false;
      if(currentSlide == 0 && nextSlide == slick.slideCount-1) {
        console.log('first to last .slick-slide.nextSlide', slick.$slides, reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]'));
        setPositionEvent = true;
        firstToLastEvent = true;
        reference_list.find('.slick-slide').removeClass('slick-slide-no-transition');
        reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]').removeClass (function (index, className) {
          return (className.match (/(^|\s)slick-slide-(before|after)-\d+/g) || []).join(' ');
        });
        reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]').prevAll().each(function(i,el){
          // if(i == 0) {
          //   $(el).removeClass (function (index, className) {
          //     return (className.match (/(^|\s)slick-slide-(before|after)-\d+/g) || []).join(' ');
          //   });
          // }
          // if(i != 0 && i < 3) {
          if(i < 5) {
            $(el).removeClass (function (index, className) {
              return (className.match (/(^|\s)slick-slide-(before|after)-\d+/g) || []).join(' ');
            });
            $(el).addClass('slick-slide-before-'+i);
          }
        });
        // reference_list.find('.slick-current').nextAll().each(function(i,el){
        reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]').nextAll().each(function(i,el){
          // if(i == 0) {
          //   $(el).removeClass (function (index, className) {
          //     return (className.match (/(^|\s)slick-slide-(before|after)-\d+/g) || []).join(' ');
          //   });
          // }
          // if(i != 0 && i < 3) {
          if(i < 5) {
            $(el).removeClass (function (index, className) {
              return (className.match (/(^|\s)slick-slide-(after|before)-\d+/g) || []).join(' ');
            });
            $(el).addClass('slick-slide-after-'+i);
          }
        });
      }
      if(currentSlide == slick.slideCount-1 && nextSlide == 0) {
        console.log('last to first');
        setPositionEvent = true;
        lastToFirstEvent = true;

        reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]').prevAll().each(function(i,el){
          // if(i != 0 && i < 3) {
          if(i < 5) {
            $(el).removeClass (function (index, className) {
              return (className.match (/(^|\s)slick-slide-(before|after)-\d+/g) || []).join(' ');
            });
            $(el).addClass('slick-slide-before-'+i);
          }
        });
        // reference_list.find('.slick-current').nextAll().each(function(i,el){
        reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]').nextAll().each(function(i,el){
          // if(i != 0 && i < 3) {
          if(i < 5) {
            $(el).removeClass (function (index, className) {
              return (className.match (/(^|\s)slick-slide-(after|before)-\d+/g) || []).join(' ');
            });
            $(el).addClass('slick-slide-after-'+i);
          }
        });
      }
      if(setPositionEvent === false) {
        reference_list.find('.slick-slide').removeClass (function (index, className) {
          return (className.match (/(^|\s)slick-slide-before-\d+/g) || []).join(' ');
        });
        // reference_list.find('.slick-current').prevAll().each(function(i,el){
        reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]').prevAll().each(function(i,el){
          // if(i != 0) {
            $(el).addClass('slick-slide-before-'+i);
          // }
        });
        reference_list.find('.slick-slide').removeClass (function (index, className) {
          return (className.match (/(^|\s)slick-slide-after-\d+/g) || []).join(' ');
        });
        // reference_list.find('.slick-current').nextAll().each(function(i,el){
        reference_list.find('.slick-slide[data-slick-index="'+nextSlide+'"]').nextAll().each(function(i,el){
          // if(i != 0) {
            $(el).addClass('slick-slide-after-'+i);
          // }
        });
      }
    }).on('afterChange', function(event, slick, currentSlide){
      // if(afterChangeEvent === true) {
      //   if(currentSlide ==  slick.slideCount-1 ) {
      //     console.log('first to last after');
      //
      //   }
      //   if(currentSlide == 0) {
      //     console.log('last to first after');
      //   }
      // }
      reference_list.find('.slick-slide').removeClass('slick-slide-no-transition');
    }).on('setPosition', function(event, slick) {

      reference_list.find('.slick-slide').removeClass('slick-slide-no-transition');
      if(setPositionEvent === true) {
        reference_list.find('.slick-slide').addClass('slick-slide-no-transition');
        if(firstToLastEvent === true) {

          reference_list.find('.slick-slide').removeClass (function (index, className) {
            return (className.match (/(^|\s)slick-slide-before-\d+/g) || []).join(' ');
          });
          // reference_list.find('.slick-current').prevAll().each(function(i,el){
          reference_list.find('.slick-slide[data-slick-index="'+(slick.slideCount-1)+'"]').prevAll().each(function(i,el){
            // if(i != 0) {
              $(el).addClass('slick-slide-before-'+i);
            // }
          });
          reference_list.find('.slick-slide').removeClass (function (index, className) {
            return (className.match (/(^|\s)slick-slide-after-\d+/g) || []).join(' ');
          });
          // reference_list.find('.slick-current').nextAll().each(function(i,el){
          reference_list.find('.slick-slide[data-slick-index="'+(slick.slideCount-1)+'"]').nextAll().each(function(i,el){
            // if(i != 0) {
              $(el).addClass('slick-slide-after-'+i);
            // }
          });
        }
        if(lastToFirstEvent === true) {

          reference_list.find('.slick-slide').removeClass (function (index, className) {
            return (className.match (/(^|\s)slick-slide-before-\d+/g) || []).join(' ');
          });
          // reference_list.find('.slick-current').prevAll().each(function(i,el){
          reference_list.find('.slick-slide[data-slick-index="0"]').prevAll().each(function(i,el){
            // if(i != 0) {
              $(el).addClass('slick-slide-before-'+i);
            // }
          });
          reference_list.find('.slick-slide').removeClass (function (index, className) {
            return (className.match (/(^|\s)slick-slide-after-\d+/g) || []).join(' ');
          });
          // reference_list.find('.slick-current').nextAll().each(function(i,el){
          reference_list.find('.slick-slide[data-slick-index="0"]').nextAll().each(function(i,el){
            // if(i != 0) {
              $(el).addClass('slick-slide-after-'+i);
            // }
          });
        }
      }
    });
  }, 1500 );

}



// WEBPACK FOOTER //
// ./scripts/components/footer.js